import { all, put, takeLatest } from "redux-saga/effects";
import { showLoading, hideLoading } from "../../actions/Login/action";
import * as constants from "../../utils/constants";
import request from "../../utils/request";
import {
  SelectDriverList,
  assignDriverToShipmentResponse,
  getPredecessorShipmentResponse,
  successorShipmentResponse,
  publishCarrierIntentMessageResponse
} from '../../actions/carrierAssign/action';
import { DomainConverter, isMobile } from '../../utils/common';
import { fetchResults } from "../../actions/Search/action"
import { ToastMessage } from "../../utils/ToastMessage";

export function* fetchDriverListResults(data: any) {
  try {
    yield put(showLoading());
    const driverlistReqestQuery = DomainConverter.domainToData<any>(
      data.payload
    );
    const response = yield request<any>([
      "DRIVERS_LIST",
      "DRIVERS_LIST",
      null,
      "",
      driverlistReqestQuery,
      "application/json",
    ]);
    const driverList =
      (response && response.data && response.data.getMembers) || [];
    yield put(SelectDriverList(driverList));
    yield put(hideLoading());
  } catch (e) {
    yield put(hideLoading());
  }
}

export function* assignDriverToShipmentSaga(data: any) {
  try {
    yield put(showLoading());
    const mutationQuery = DomainConverter.domainToData<any>(data.payload);
    const response = yield request<any>([
      "MYLOAD",
      "CARRIER_WITH_EXPERIENCE",
      null,
      "",
      mutationQuery,
      "application/json",
    ]);
    yield put(hideLoading());

    yield put(
      assignDriverToShipmentResponse({
        assignDriverToShipment:
          (response.data && response.data.assignDriverV2) || false,
        errors: response.errors,
      })
    );
    yield put(
      successorShipmentResponse(response.data && response.data.assignDriverV2 && response.data.assignDriverV2.successor)
    )

    if (data.callback) {
      data.callback(
        response.data &&
        response.data.assignDriverV2 &&
        response.data.assignDriverV2,
        response && response.errors && response.errors.length > 0
      );
    }
  } catch (e) {
    yield put(hideLoading());
  }
}

export function* unAssignDriverToShipmentSaga(data: any) {
  try {
    yield put(showLoading());
    const mutationQuery = DomainConverter.domainToData<any>(data.payload);
    const response = yield request<any>([
      'MYLOAD',
      'CARRIER_WITH_EXPERIENCE',
      null,
      '',
      mutationQuery,
      'application/json'
    ]);
    yield put(hideLoading());
    if (data && data.callBack) {
      data.callBack({
        unassignDriverFromShipment:
          (response.data && response.data.unassignDriverFromShipment) || false,
        errors: response.errors || [],
      });
    }
    yield put(hideLoading());
  } catch (e) {
    yield put(hideLoading());
  }
}

export function* getPredecessorShipment(action: {type:string,payload:any}) {
  try {
    yield put(showLoading());
    const mutationQuery = DomainConverter.domainToData<any>(action.payload?.data);
    const response = yield request<any>([
      'MYLOAD',
      'CARRIER_WITH_EXPERIENCE',
      null,
      '',
      mutationQuery,
      'application/json'
    ]);
    yield put(hideLoading());
    if (response) {
      if(action.payload?.callBack){
        action.payload?.callBack(response);
      }
      yield put(getPredecessorShipmentResponse(response.data));
      if (response.errors) {
        response.errors && response.errors.length > 0 &&
          response.errors.map((error: any) => {
            (isMobile) ? ToastMessage.show(error.errorType)
              : ToastMessage.showWeb(error.errorType)
          })
      }
    }
  } catch (e) {
    yield put(hideLoading());
  }
}

export function* carrierIntentMessage(data: any) {
  try {
    yield put(showLoading());
    if (data.payload.reload) {
      yield put(fetchResults(data.payload.loadPostingData, false, false, data.payload.callback))
    }
    const carrierIntentResponse = yield request<any>([
      "CARRIER_INTENT",
      "CARRIER_INTENT",
      null,
      '',
      data.payload.intentPayload,
      'application/json'
    ])

    yield put(hideLoading())
    yield put(publishCarrierIntentMessageResponse(carrierIntentResponse))

  } catch (e) {
    yield put(hideLoading());
  }
}

export default function* rootSaga() {
  yield all([
    takeLatest(constants.ASSIGN_DRIVER, fetchDriverListResults),
    takeLatest(
      constants.CarrierActionTypes.ASSIGN_DRIVER_TO_SHIPMENT,
      assignDriverToShipmentSaga
    ),
    takeLatest(
      constants.CarrierActionTypes.UN_ASSIGN_DRIVER_TO_SHIPMENT,
      unAssignDriverToShipmentSaga
    ),
    takeLatest(
      constants.CarrierActionTypes.GET_PREDECESSOR_SHIPMENT,
      getPredecessorShipment),
    takeLatest(constants.CarrierActionTypes.CARRIER_INTENT_MESSAGE,
      carrierIntentMessage)
  ]);
}
